import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class PlannerConfirmationComponent implements OnInit {

  public data: any = null;

  constructor(
    private router: Router
  ) {
    this.data = this.router.getCurrentNavigation()?.extras?.state || null;
  }

  ngOnInit(): void {
    if (this.data === null) {
      this.gotoOrderform();
    }
  }

  public gotoOrderform(): void {
    this.router.navigate(['/planning/orderform']);
  }

}
